import { Contract, Provider, Signer } from "koilib";
import { CONFIG_BASE } from "./../constants/configs";

// abis
import CoreAbi from "./../assets/abis/core-abi.json";
import PeripheryAbi from "./../assets/abis/periphery-abi.json";
import StakingAbi from "./../assets/abis/staking-abi.json";
import TokenAbi from "./../assets/abis/token-abi.json";
import NameserviceAbi from "./../assets/abis/nameservice-abi.json";

// variables
// VITE_RPC accepts a comma separated list of nodes, the extra ones are used as fallback
const rpcNodes = (import.meta.env.VITE_RPC || "")
  .split(",")
  .map((node) => node.trim())
  .filter(Boolean);
export const defaultProvider = new Provider(rpcNodes);
const provider = defaultProvider;
const signer = Signer.fromSeed("demo seed");

export let PeripheryContract = (_provider, _signer) =>
  new Contract({
    id: CONFIG_BASE.contracts.periphery.address,
    abi: PeripheryAbi,
    provider: _provider ? _provider : provider,
    signer: _signer ? _signer : signer,
  });

export let CoreContract = (_address, _provider, _signer) =>
  new Contract({
    id: _address,
    abi: CoreAbi,
    provider: _provider ? _provider : provider,
    signer: _signer ? _signer : signer,
  });

export let StakingContract = (_address, _provider, _signer) =>
  new Contract({
    id: _address,
    abi: StakingAbi,
    provider: _provider ? _provider : provider,
    signer: _signer ? _signer : signer,
  });

export let TokenContract = (address, _provider, _signer) =>
  new Contract({
    id: address,
    abi: TokenAbi,
    provider: _provider ? _provider : provider,
    signer: _signer ? _signer : signer,
  });

export let NameServiceContract = (_provider, _signer) =>
  new Contract({
    id: CONFIG_BASE.chain.contracts.nameservice,
    abi: NameserviceAbi,
    provider: _provider ? _provider : provider,
    signer: _signer ? _signer : signer,
  });
